export default "/images/vendor/flag-icons/flags/4x3/et.svg?9d978f590f49d13633f32b99c2799020";